var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('files',{attrs:{"payload":{ resource_id: _vm.payload.resource_id, resource_type: _vm.payload.resource_type, show_checkboxes: false }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }